"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkIfLoginDisabled = exports.validateLoginForm = exports.loginInitialTouchedFieldsState = exports.loginInitialErrorState = void 0;
const utils_1 = require("../utils");
exports.loginInitialErrorState = {
    email: "",
    password: "",
};
exports.loginInitialTouchedFieldsState = {
    email: false,
    password: false,
};
const validateLoginForm = (email, password, touchedFields) => {
    const fields = Object.keys(touchedFields);
    const errors = {
        email: "",
        password: "",
    };
    fields.forEach(field => {
        const touched = touchedFields[field];
        if (!touched)
            return;
        switch (field) {
            case "email":
                errors["email"] = (0, utils_1.isValidEmail)(email) ? "" : "emailError";
                break;
            case "password":
                errors["password"] = password.length > 0 ? "" : "passwordError";
                break;
        }
    });
    return errors;
};
exports.validateLoginForm = validateLoginForm;
const checkIfLoginDisabled = (email, password, errors) => {
    if (!email || !password) {
        return true;
    }
    return !!errors.email || !!errors.password;
};
exports.checkIfLoginDisabled = checkIfLoginDisabled;
